import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  cta_buttonSecondaryBackground,
  cta_buttonSecondaryBackgroundHover,
  cta_buttonSecondaryBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextSuccess,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${spacing(5)};
  min-height: 0;

  .ReceiptEvidencePanel--action-bar,
  .ReceiptEvidencePanel--action-group,
  .ReceiptEvidencePanel--metadata,
  .ReceiptEvidencePanel--provenance,
  .ReceiptEvidencePanel--verified,
  .ReceiptEvidencePanel--unavailable {
    display: flex;
    align-items: center;
  }

  .ReceiptEvidencePanel--action-bar {
    justify-content: space-between;
  }

  .ReceiptEvidencePanel--action-group {
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--icon-button {
    display: inline-flex;
    box-sizing: border-box;
    flex: 0 0 ${spacing(8)};
    align-items: center;
    justify-content: center;
    width: ${spacing(8)};
    height: ${spacing(8)};
    padding: ${spacing(2)};
    color: ${text_colorTextPrimary};
    background: ${cta_buttonSecondaryBackground};
    border: 1px solid ${cta_buttonSecondaryBorder};
    border-radius: ${cornerRadius};
    cursor: pointer;
    line-height: 0;
    text-decoration: none;
    transition: background-color 150ms ease-in-out;

    &:hover:not(:disabled) {
      background: ${cta_buttonSecondaryBackgroundHover};
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .ReceiptEvidencePanel--action-icon {
    position: relative;
    display: block;
    flex: 0 0 ${spacing(4)};
    width: ${spacing(4)};
    height: ${spacing(4)};

    img {
      position: absolute;
      display: block;
      max-width: none;
    }
  }

  .ReceiptEvidencePanel--action-icon-external-link img {
    top: 2.33px;
    left: 2.17px;
    width: 11.8564px;
    height: 11.5049px;
  }

  .ReceiptEvidencePanel--action-icon-delete img {
    top: 2.83px;
    left: 3.17px;
    width: 9.66602px;
    height: 10.667px;
  }

  .ReceiptEvidencePanel--action-icon-download svg {
    display: block;
    width: ${spacing(4)};
    height: ${spacing(4)};
  }

  .ReceiptEvidencePanel--action-icon-plus img {
    top: 3.83px;
    left: 3.83px;
    width: 9px;
    height: 9px;
  }

  .ReceiptEvidencePanel--action-icon-collapse img {
    top: 3.83px;
    left: 7.83px;
    width: 1px;
    height: 9px;
    transform: rotate(90deg);
  }

  .ReceiptEvidencePanel--preview {
    display: flex;
    flex: 0 0 ${spacing(160)};
    align-items: center;
    justify-content: center;
    height: ${spacing(160)};
    min-height: ${spacing(100)};
    overflow: hidden;
    background: ${base_colorSurfaceSecondary};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${cornerRadius};
  }

  .ReceiptEvidencePanel--preview-image,
  .ReceiptEvidencePanel--preview-document {
    width: 100%;
    height: 100%;
    border: 0;
  }

  .ReceiptEvidencePanel--preview-image {
    object-fit: contain;
    background: ${base_colorRaisedSurface};
    transition: transform 150ms ease-in-out;

    &.isZoomed {
      transform: scale(1.5);
    }
  }

  .ReceiptEvidencePanel--unavailable {
    flex-direction: column;
    gap: ${spacing(2)};
    margin: ${spacing(6)};
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
    text-align: center;
  }

  .ReceiptEvidencePanel--divider {
    width: 100%;
    height: 1px;
    background: ${base_colorContentBorder};
  }

  .ReceiptEvidencePanel--comparison {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    width: 100%;
    margin: 0;

    > div {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: baseline;
      gap: ${spacing(4)};
    }

    dt {
      color: ${text_colorTextSecondary};
      font-family: ${font_family_weight_regular};
      ${font_md}
    }

    dd {
      max-width: ${spacing(100)};
      margin: 0;
      color: ${text_colorTextPrimary};
      font-family: ${font_family_weight_regular};
      ${font_sm}
      text-align: right;
    }

    .ReceiptEvidencePanel--difference {
      font-family: ${font_family_weight_medium};
    }
  }

  .ReceiptEvidencePanel--metadata {
    flex-wrap: wrap;
    gap: ${spacing(1)};
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }

  .ReceiptEvidencePanel--provenance,
  .ReceiptEvidencePanel--verified {
    gap: ${spacing(1)};
  }

  .ReceiptEvidencePanel--provenance img {
    width: ${spacing(4)};
    height: ${spacing(4)};
  }

  .ReceiptEvidencePanel--verified {
    color: ${text_colorTextSuccess};
  }
`
